import axiosApi from "./axios.js";
import store from "../store/store.js";
import { isBlobReuqest } from '../common/js/publicUtil'

export default {
  install: function(Vue, options) {
    // 二次封装axios 只取数据data部分 并且以promise对象返回
    let n = 0;
    Vue.prototype.axiosPost = function Post(url, data, loading) {
      if (loading) {
        n++;
        store.commit("LOADING", true);
        store.state.loading = true;
      }
      return axiosApi.post(url, data).then((res) => {
        if (loading) {
          n--;
          if (n === 0) {
            store.state.loading = false;
            store.commit("LOADING", false);
          }
        }
        return Promise.resolve(res.data);
      });
    };
    // 二次封装axios get请求
    Vue.prototype.axiosGet = function Get(url, data) {
      return axiosApi.get(url, data).then((res) => {
        return Promise.resolve(res.data);
      });
    };
    // 二次封装axios uploadfile请求
    Vue.prototype.uploadfile = function Get(url, data) {
      return axiosApi.uploadfile(url, data).then((res) => {
        return Promise.resolve(res.data);
      });
    };

    Vue.prototype.httpPost = function Post(url, data, loading) {
      if (loading) {
        n++;
        store.commit("LOADING", true);
        store.state.loading = true;
      }
      return axiosApi.httpPost(url, data).then((res) => {
        if (loading) {
          n--;
          if (n === 0) {
            store.state.loading = false;
            store.commit("LOADING", false);
          }
        }
        if (isBlobReuqest(url)) {
          return Promise.resolve(res);
        } else {
          return Promise.resolve(res.data);
        }
      });
    };
    // 二次封装axios get请求
    Vue.prototype.httpGet = function Get(url, data, loading) {
      if (loading) {
        n++;
        store.commit("LOADING", true);
        store.state.loading = true;
      }
      return axiosApi.httpGet(url, data).then((res) => {
        if (loading) {
          n--;
          if (n === 0) {
            store.state.loading = false;
            store.commit("LOADING", false);
          }
        }
        if (isBlobReuqest(url)) {
          return Promise.resolve(res);
        } else {
          return Promise.resolve(res.data);
        }
      });
    };

    // 废弃
    Vue.prototype.httpProxyPost = function Post(url, data, loading) {
      return axiosApi.httpProxyPost(url, data).then((res) => {
        if (res.data && res.data.data) {
          return Promise.resolve(res.data.data);
        } else {
          return Promise.resolve(res.data);
        }
      });
    };
  },
};



// WEBPACK FOOTER //
// ./src/axios/install.js